module.exports = __webpack_public_path__ + "static/img/demo-2.ebeda3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/demo-2.png
// module id = 2KCh
// module chunks = 1